/**
 * Product Recommendations V2 (idempotent)
 * - Safe to include multiple times without errors
 */

;(function(){
  if (!window.ProductRecommendations) {
    window.ProductRecommendations = class ProductRecommendations extends HTMLElement {
      constructor() {
        super();
        this.init();
      }

      init() {
        const handleIntersection = (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);
          this.fetchRecommendations();
        };

        // Use Intersection Observer for performance
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(handleIntersection.bind(this), {
            rootMargin: '0px 0px 400px 0px'
          }).observe(this);
        } else {
          // Fallback for older browsers
          this.fetchRecommendations();
        }
      }

      fetchRecommendations() {
        const url = this.dataset.url;
        if (!url) return;

        fetch(url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              this.classList.add('product-recommendations--loaded');
              
              // Initialize any scripts that might be needed
              this.initializeScripts();
            } else {
              this.style.display = 'none';
            }
          })
          .catch(error => {
            console.warn('Failed to load product recommendations:', error);
            this.style.display = 'none';
          });
      }

      initializeScripts() {
        // Initialize any card hover effects or other interactions
        const cards = this.querySelectorAll('.card-wrapper');
        cards.forEach(card => {
          // Add any card-specific interactions here if needed
          // For now, CSS handles all the hover effects
        });

        // Trigger scroll animations if enabled
        if (window.theme && window.theme.initializeScrollAnimationTrigger) {
          window.theme.initializeScrollAnimationTrigger(this);
        }
      }
    }
  }

  // Register the custom element once
  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', window.ProductRecommendations);
  }
})();